import React, { useState } from 'react';
import { Else, If, Then } from 'react-if';
import { useModal } from '@ebay/nice-modal-react';
import { useIsMounted } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useIsomorphicViewportDevice } from '@zep/react';
import { UploadTypeSelectionModal } from '../../components';
import ShowDesktop from '../../components/common/ShowDesktop';
import { ZemColorIcon } from '../../components/icons';
import Empty from '../../components/service/common/Empty';
import SaleList from '../../components/service/manages/SaleList';
import { useSales } from '../../services';
import S from './AssetControl.module.scss';
export const SalesPageView = () => {
  const uploadModal = useModal(UploadTypeSelectionModal);
  const {
    t
  } = useTranslation(['manage']);
  const {
    isMobile
  } = useIsomorphicViewportDevice();
  const [page, setPage] = useState(1);
  const {
    data
  } = useSales(page);
  const isMounted = useIsMounted();
  const handleUploadAssetModalShow = () => {
    logger.track('store_upload_btn');
    void uploadModal.show();
  };
  return <If condition={!isMounted || isMobile} data-sentry-element="If" data-sentry-component="SalesPageView" data-sentry-source-file="sales.tsx">
      <Then data-sentry-element="Then" data-sentry-source-file="sales.tsx">
        <ShowDesktop data-sentry-element="ShowDesktop" data-sentry-source-file="sales.tsx" />
      </Then>
      <Else data-sentry-element="Else" data-sentry-source-file="sales.tsx">
        <div className={S.page_title}>{t('manage:manage_sales')}</div>
        <If condition={data.sales?.length > 0} data-sentry-element="If" data-sentry-source-file="sales.tsx">
          <Then data-sentry-element="Then" data-sentry-source-file="sales.tsx">
            <div className={S.total_revenue_title}>
              {t('manage:manage_total_revenue')}
            </div>
            <div className={S.total_revenue_value}>
              <span className={S.total_revenue_zem_icon}>
                <ZemColorIcon width={24} height={24} data-sentry-element="ZemColorIcon" data-sentry-source-file="sales.tsx" />
              </span>
              <span className={S.total_revenue_zem_amount}>
                {data.totalRevenue.toLocaleString()}
              </span>
            </div>
            <SaleList sales={data.sales} lastPageNo={data.pager?.totalPages} nowPageNo={data.pager?.currentPage} handlePageChange={setPage} data-sentry-element="SaleList" data-sentry-source-file="sales.tsx" />
          </Then>
          <Else data-sentry-element="Else" data-sentry-source-file="sales.tsx">
            <Empty image={{
            url: '/images/light/assetStore/empty_box.png',
            width: 125,
            height: 125
          }} emptyItem={t('manage:sales.empty.titleItem')} description={t('manage:myAsset.empty.description')} ctaText={t('store_asset_upload', {
            ns: 'store'
          })} onClickCTA={() => handleUploadAssetModalShow()} data-sentry-element="Empty" data-sentry-source-file="sales.tsx" />
          </Else>
        </If>
      </Else>
    </If>;
};